import { render, staticRenderFns } from "./JSelectBizComponentModal.vue?vue&type=template&id=53863efc&scoped=true"
import script from "./JSelectBizComponentModal.vue?vue&type=script&lang=js"
export * from "./JSelectBizComponentModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectBizComponentModal.vue?vue&type=style&index=0&id=53863efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53863efc",
  null
  
)

export default component.exports